import type {
  ChartType as ChartJSChartType,
  ChartDataset as ChartJSChartDataset,
  ChartOptions,
  TimeUnit,
} from 'chart.js'
import type { ScatterDataPoint } from '../types'

export type ChartType = Extract<ChartJSChartType, 'line' | 'bar'>

export type ChartDataset = Omit<ChartJSChartDataset, 'data'> & {
  label: NonNullable<ChartJSChartDataset['label']>
  data: Array<ScatterDataPoint>
}
interface BaseChartData {
  type: ChartType
  datasets: Array<ChartDataset>
  yAxisID?: 'y' | 'y1'
}

interface BarChartData extends BaseChartData {
  type: 'bar'
  backgroundColors: Array<string>
}

interface LineChartData extends BaseChartData {
  type: 'line'
  borderColors: Array<string>
  connectedChartIndex?: number
}

export type MultiChartData = BarChartData | LineChartData

export type AxisOptions = {
  axisLabel?: string
  min?: number | string
  max?: number | string
  offset?: boolean
}

export interface XAxisOptions extends AxisOptions {
  timeUnit?: TimeUnit
}

export enum TickFormat {
  Default = 'default',
  CurrencyUSD = 'currencyUSD',
}

export interface YAxisOptions extends AxisOptions {
  tickFormat?: TickFormat
}

export interface MultiChartProps extends BaseComponentProps {
  className?: string
  data: Array<MultiChartData>
  enableFiltering?: boolean
  hideGridLines?: boolean
  isLoading?: boolean
  labels: Array<string>
  legendPosition?: 'right' | 'bottom' | 'left' | 'top' | 'none'
  showNoDataOverlay?: boolean
  tooltipOptions?: NonNullable<ChartOptions['plugins']>['tooltip']
  xAxisOptions?: XAxisOptions
  y1AxisOptions?: YAxisOptions
  yAxisOptions?: YAxisOptions
}
